import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'

interface ComparisonBarChartProps {
  projects: string[]
  data: Array<{ name: string; data: (number | null)[] }>
  colors: string[]
}

const ComparisonBarChart: React.FC<ComparisonBarChartProps> = ({ projects, data, colors }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(projects, data, colors, mode))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, projects, data, colors])

  return (
    <div
      ref={chartRef}
      id='kt_charts_comparison_bar_chart'
      style={{ height: '400px' }}
      className='card-rounded-bottom'></div>
  )
}

function getChartOptions(
  projects: string[],
  data: Array<{ name: string; data: (number | null)[] }>,
  colors: string[],
  mode: string
): ApexOptions {
  const textColor = mode === 'dark' ? '#A1A5B7' : '#7E8299'

  return {
    series: data,
    colors: colors,
    chart: {
      type: 'bar',
      height: 400,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '100%',
        borderRadius: 8,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        colors: ['#000000'],
        fontSize: '10px',
        fontWeight: 'light',
      },
    },
    xaxis: {
      categories: projects,
      labels: {
        style: {
          fontSize: '10px',
          colors: textColor,
        },
      },
    },
    yaxis: {
      title: {
        text: 'โครงการ',
        style: {
          color: textColor,
        },
      },
      labels: {
        style: {
          fontSize: '16px',
          colors: textColor,
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + ''
        },
      },
    },
  }
}

export default ComparisonBarChart
